<template>
  <base-container
    title="Collaboration Hub"
    viewLink="/collaboration"
    :withGradient="questions.length > 1"
    header-central
    no-padding
    :class="cssLabel"
  >
    <base-scroll-list
      :items="questions"
      circle
      :tabs="collaborationTabs"
      isQuestion
      noBottom
      header-central
      @tabClick="setActiveTab"
    >
      <ol v-if="questions.length > 0" role="list">
        <li v-for="(question, index) in questions" :key="index" role="listitem">
          <question-item
            class="question-item"
            :key="question.id"
            :questionData="question"
            @click="handleCollabClick(question)"
            :showResponseCount="false"
          ></question-item>
        </li>
      </ol>
      <p v-else>There are currently no collaboration questions</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
import UserHasPermission from "@/mixins/UserHasPermission";
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

const QuestionItem = () => import("@/components/QuestionItem");
export default {
  name: "CollabWidget",

  components: {
    BaseContainer,
    BaseScrollList,
    QuestionItem,
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
    cssClass: {
      type: [String, Number],
    },
  },

  mixins: [UserHasPermission],

  data() {
    return {
      activeTab: null,
      questions: [],
    };
  },

  computed: {
    storeItems() {
      return this.$store.getters["widgets/collab/open_questions"];
    },
    cssLabel() {
      if (this.cssClass === 4) {
        return "c-container--sm";
      }
      if (this.cssClass === 6) {
        return "c-container--md";
      }
      return "c-container--lg";
    },
    collaborationTabs() {
      if (this.isInGroup("collaboration_manager")) {
        return [
          {
            id: "all",
            label: "All Questions",
            active: true,
            dispatchAction: "widgets/collab/getUserFeed",
          },
          {
            id: "user",
            label: "My Questions",
            active: false,
            dispatchAction: "widgets/collab/getMyQuestions",
          },
        ];
      }

      return [];
    },
  },

  methods: {
    handleCollabClick(question) {
      this.$router.push({
        name: "CollaborationQuestion",
        params: { questionId: question.id },
      });
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      if (tab.id === "user") {
        this.questions = this.$store.getters[
          "widgets/collab/user_questions"
        ].slice(0, this.limit);
      } else {
        this.questions = this.$store.getters["widgets/collab/open_questions"].slice(
          0,
          this.limit
        );
      }
    },
  },

  async mounted() {
    await this.$store.dispatch("widgets/collab/setLimit", this.limit);
    await this.$store.dispatch("widgets/collab/getLargestLimit");
    this.$store.dispatch("widgets/collab/getUserFeed").then(() => {
      this.activeTab = this.collaborationTabs[0];
    });
  },
  watch: {
    storeItems: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.questions = newVal.slice(0, this.limit);
      },
    },
    limit: {
      immediate: true,
      deep: false,
      handler(newValue, oldValue) {
        this.postLimit = newValue;
        this.$store
          .dispatch("widgets/collab/setLimit", this.postLimit)
          .then(() => {
            this.$store.dispatch("widgets/collab/clearCache").then(() => {
              this.$store
                .dispatch("widgets/collab/getUserFeed", { size: this.limit })
                .then((resp) => {
                  this.questions = resp.slice(0, this.limit);
                  this.activeTab = this.collaborationTabs[0];
                });
            });
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// styles based on width
.c-container {
  &--sm {
    /deep/ .c-question-item__view {
      display: none;
    }

    /deep/ .u-hide-mobile {
      display: none;
    }

    /deep/ .flexlist {
      width: 100%;
      justify-content: space-between;
    }

    /deep/ .list.big-padding li {
      padding: 0;
    }

    /deep/ .c-question-item__media {
      display: none;
    }
  }
  &--md {
    /deep/ .u-hide-mobile {
      display: none;
    }
  }
}
</style>
